const musicTypes = {
  TOGGLE_PLAY_MUSIC: 'TOGGLE_PLAY_MUSIC',
  SELECT_MUSIC: 'SELECT_MUSIC',
  NEXT_MUSIC: 'NEXT_MUSIC',
  PREVIOUS_MUSIC: 'PREVIOUS_MUSIC',
  FETCH_MUSIC_DATA: 'FETCH_MUSIC_DATA',
  STORE_MUSIC_DATA: 'STORE_MUSIC_DATA',
  FILTER_MUSIC: 'FILTER_MUSIC'
}

export default musicTypes
